export default () => ({
    events: null,
    event: null,
    eventsConfig: {
        include: 'author,coverMedia,reactions,comments.citizen',
        sort: 'start_date',
        sortDirection: 'desc',
        page: 1,
        per_page: 25,
        filters: {}
    }
})
